const doc = [({"en":({"js":({"admin":({"economy":({"dimensions":({"dimensions":"Dimensions"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;